var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBatteryCapacity = function SvgBatteryCapacity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E242F",
    d: "M22.332 8.667h-1.333a.667.667 0 0 0-.667.666v5.333c0 .369.299.667.667.667h1.333a.667.667 0 0 0 .667-.667V9.333a.667.667 0 0 0-.667-.667M3.645 8.563h3.333v6.875H3.645zm4.333 0h3.333v6.875H7.978zm4.333 0h3.334v6.875H12.31z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E242F",
    fillRule: "evenodd",
    d: "M17.667 6H3a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h14.667a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2M2.333 8A.667.667 0 0 1 3 7.333h14.667a.667.667 0 0 1 .666.667v8a.667.667 0 0 1-.666.667H3A.667.667 0 0 1 2.333 16z",
    clipRule: "evenodd"
  })));
};
export default SvgBatteryCapacity;